<div fxLayout="column" fxLayoutAlign="center start" mat-dialog-title class="dialog-title-container">
    <button mat-icon-button mat-dialog-close aria-label="Close dialog" class="btn-close">
        <mat-icon><img src="assets/images/icons/close.svg" alt="close"></mat-icon>
    </button>
    <div class="dialog-title" [translate]="'ChooseGroup.GroupNotAvailable'">      
    </div>
</div>

<div mat-dialog-content fxLayout="column" class="controls-container" >
    <p [translate]="'ChooseGroup.GroupNotAvailableDesc'"></p>
</div>

<div mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="1rem">
    <button mat-flat-button class="gradient-btn" color="primary" mat-dialog-close>
        <span [translate]="'ExdrCommon.OK'"></span>
    </button>
</div>